import React from 'react';

import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { Box, Flex, Inline, Stack } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

import messages from './messages';

const SKELETON_CARD_COUNT = 3;

const styles = cssMap({
	container: {
		width: '100%',
	},
	card: {
		borderStyle: 'solid',
		borderWidth: token('border.width'),
		borderColor: token('color.border'),
		borderRadius: token('radius.large'),
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
	},
	headerRow: {
		width: '100%',
	},
});

/** Renders a single placeholder project card skeleton. */
const SpaceCardSkeleton = () => {
	return (
		<Box xcss={styles.card}>
			<Stack space="space.100">
				{/* Row 1: Icon + Title */}
				<Flex justifyContent="space-between" alignItems="center" xcss={styles.headerRow}>
					<Inline space="space.150" alignBlock="center">
						<Skeleton width={32} height={32} borderRadius={token('radius.tile')} isShimmering />
						<Skeleton width={120} height={16} borderRadius={token('radius.small')} isShimmering />
					</Inline>
				</Flex>

				{/* Row 2: Description text (two lines) */}
				<Skeleton width="80%" height={14} borderRadius={token('radius.small')} isShimmering />
				<Skeleton width="60%" height={14} borderRadius={token('radius.small')} isShimmering />
			</Stack>
		</Box>
	);
};

/**
 * Shimmer/skeleton loading state rendered as the Suspense fallback for MySpacesList.
 * Renders placeholder space cards that match the ThreadCard layout dimensions.
 */
export const MySpacesSkeleton = (): React.JSX.Element => {
	const intl = useIntl();

	return (
		<Box
			xcss={styles.container}
			role="group"
			aria-label={intl.formatMessage(messages.loadingSpacesLabel)}
		>
			<Stack space="space.200">
				{Array.from({ length: SKELETON_CARD_COUNT }, (_, index) => (
					<SpaceCardSkeleton key={index} />
				))}
			</Stack>
		</Box>
	);
};
